const ar = {
  "component.anime_series_carousel.possessivetitle": "الأنمي المفضل لدى {name}",
  "component.anime_series_carousel.title": "الأنمي المفضل لدى {name}",
  "component.article_card.aria.comment_button": "علق على المقالة",
  "component.article_card.aria.share_button": "شارك المقالة",
  "component.article_listing_by_cateogry_widget.headline": "مقالات ذات صلة",
  "component.articledetail.share": "شارك",
  "component.articlepanels.html5audioembed.unsupported_message":
    '"المتصفح الخاص بك لا يدعم صوت HTML"',
  "component.articlepanels.html5videoembed.unsupported_message":
    '"المتصفح الخاص بك لا يدعم فيديو HTML"',
  "component.authorpage.all_articles_by": '"كل مقالات {name}"',
  "component.authorpage.no_articles_found": '"لا توجد مقالات لهذا الكاتب"',
  "component.latest_news_featured_widget.all_button": "كل الأخبار",
  "component.latest_news_featured_widget.headline": "آخر الأخبار",
  "component.latest_news_widget.all_button": "كل الأخبار",
  "component.latest_news_widget.headline": "آخر الأخبار",
  "component.navbar.aria.account_menu": "قائمة الحساب",
  "component.navbar.aria.account_thumbnail_alt": "صورة المستخدم",
  "component.navbar.aria.mobile_menu_button": "قائمة",
  "component.navbar.aria.search": "بحث",
  "component.navbar.aria.search_menu": "إظهار البحث",
  "component.navbar.aria.themetoggle": "اختيار المظهر",
  "component.navbar.search.placeholder": "البحث في Crunchyroll News",
  "component.pagination.aria.next_arrow": "الصفحة التالية",
  "component.pagination.aria.previous_arrow": "الصفحة السابقة",
  "component.product_listing.headline": "مقتنيات يُنصح بها",
  "component.series_listing_widget.headline": "أنمي يُنصح بمشاهدته",
  "component.spotlight_carousel.arrow_next": "السابق",
  "component.spotlight_carousel.arrow_previous": "التالي",
  "component.spotlight_carousel.headline": "أبرز المواضيع",
  "component.top_stories_aside_widget.headline": "أشهر المواضيع",
  "component.top_stories_panel.headline": "أشهر المواضيع",
  "page.article.share": "شارك المقالة",
  "page.home.scroll": "العودة إلى الأعلى",
  "page.search.filter.category.label": "التصنيفات",
  "page.search.filter.date.all": "كل الأوقات",
  "page.search.filter.date.label": "تاريخ",
  "page.search.filter.date.month": "قبل شهر",
  "page.search.filter.date.today": "قبل 24 ساعة",
  "page.search.filter.date.week": "قبل أسبوع",
  "page.search.filter.date.year": "هذا العام",
  "page.search.filter.sort.label": "فرز حسب",
  "page.search.filter.sort.newest": "من أجدد إلى أقدم",
  "page.search.filter.sort.oldest": "من أقدم إلى أجدد",
  "page.search.filter.sort.relevancy": "الصلة",
  "page.search.header.placeholder": "بحث",
  "page.search.header.results_for": '"إظهار نتائج بحث لـ:"',
  "page.search.no_results": "لا توجد نتائج",
  "page.tagresultspage.breadcrumbs.crunchyroll": "كرانشي رول",
};

const de = {
  "component.anime_series_carousel.possessivetitle": "{name} Anime-Favoriten",
  "component.anime_series_carousel.title": "{name}s Anime-Favoriten",
  "component.article_card.aria.comment_button": "Artikel kommentieren",
  "component.article_card.aria.share_button": "Artikel teilen",
  "component.article_listing_by_cateogry_widget.headline": "Ähnliche Artikel",
  "component.articledetail.share": "Teilen",
  "component.articlepanels.html5audioembed.unsupported_message":
    "Dein Browser unterstützt kein HTML-Audio.",
  "component.articlepanels.html5videoembed.unsupported_message":
    "Dein Browser unterstützt kein HTML-Video.",
  "component.authorpage.all_articles_by": "Alle Artikel von {name}",
  "component.authorpage.no_articles_found":
    "Keine Artikel für diesen Autor gefunden",
  "component.latest_news_featured_widget.all_button": "Alle News",
  "component.latest_news_featured_widget.headline": "Aktuellste News",
  "component.latest_news_widget.all_button": "Alle News",
  "component.latest_news_widget.headline": "Aktuellste News",
  "component.navbar.aria.account_menu": "Kontoübersicht",
  "component.navbar.aria.account_thumbnail_alt": "Benutzerbild",
  "component.navbar.aria.mobile_menu_button": "Menü",
  "component.navbar.aria.search": "Suchen",
  "component.navbar.aria.search_menu": "Suche umschalten",
  "component.navbar.aria.themetoggle": "Design wechseln",
  "component.navbar.search.placeholder": "Crunchyroll News durchsuchen",
  "component.pagination.aria.next_arrow": "Nächste Seite",
  "component.pagination.aria.previous_arrow": "Vorherige Seite",
  "component.product_listing.headline": "Empfohlene Produkte",
  "component.series_listing_widget.headline": "Empfohlene Inhalte",
  "component.spotlight_carousel.arrow_next": "Nächstes Bild",
  "component.spotlight_carousel.arrow_previous": "Vorheriges Bild",
  "component.spotlight_carousel.headline": "Spotlight",
  "component.top_stories_aside_widget.headline": "Die wichtigsten News",
  "component.top_stories_panel.headline": "Die wichtigsten News",
  "page.article.share": "Artikel teilen",
  "page.home.scroll": "Zurück nach oben",
  "page.search.filter.category.label": "Kategorien",
  "page.search.filter.date.all": "Alle",
  "page.search.filter.date.label": "Datum",
  "page.search.filter.date.month": "Vergangener Monat",
  "page.search.filter.date.today": "Letzte 24 Stunden",
  "page.search.filter.date.week": "Letzte Woche",
  "page.search.filter.date.year": "Dieses Jahr",
  "page.search.filter.sort.label": "Sortieren nach",
  "page.search.filter.sort.newest": "Neu bis alt",
  "page.search.filter.sort.oldest": "Alt bis neu",
  "page.search.filter.sort.relevancy": "Relevanz",
  "page.search.header.placeholder": "Suchen",
  "page.search.header.results_for": "Anzeige der Ergebnisse für:",
  "page.search.no_results": "Keine Ergebnisse gefunden",
  "page.tagresultspage.breadcrumbs.crunchyroll": "Crunchyroll",
};

const en = {
  "component.anime_series_carousel.possessivetitle": "{name} Favorite Anime",
  "component.anime_series_carousel.title": "{name}'s Favorite Anime",
  "component.article_card.aria.comment_button": "Comment on Article",
  "component.article_card.aria.share_button": "Share Article",
  "component.article_listing_by_cateogry_widget.headline": "Related Articles",
  "component.articledetail.share": "Share",
  "component.articlepanels.html5audioembed.unsupported_message":
    "Your browser doesn't support HTML audio.",
  "component.articlepanels.html5videoembed.unsupported_message":
    "Your browser doesn't support HTML video.",
  "component.authorpage.all_articles_by": "All Articles By {name}",
  "component.authorpage.no_articles_found": "No Articles Found for this Author",
  "component.latest_news_featured_widget.all_button": "All News",
  "component.latest_news_featured_widget.headline": "Latest News",
  "component.latest_news_widget.all_button": "All News",
  "component.latest_news_widget.headline": "Latest News",
  "component.navbar.aria.account_menu": "Account Menu",
  "component.navbar.aria.account_thumbnail_alt": "User Thumbnail",
  "component.navbar.aria.mobile_menu_button": "Menu",
  "component.navbar.aria.search": "Search",
  "component.navbar.aria.search_menu": "Toggle Search",
  "component.navbar.aria.themetoggle": "Toggle Theme",
  "component.navbar.search.placeholder": "Search Crunchyroll News",
  "component.pagination.aria.next_arrow": "Next Page",
  "component.pagination.aria.previous_arrow": "Previous Page",
  "component.product_listing.headline": "Recommended Products",
  "component.series_listing_widget.headline": "Recommended Streaming",
  "component.spotlight_carousel.arrow_next": "Next Slide",
  "component.spotlight_carousel.arrow_previous": "Previous Slide",
  "component.spotlight_carousel.headline": "Spotlight",
  "component.top_stories_aside_widget.headline": "Top Stories",
  "component.top_stories_panel.headline": "Top Stories",
  "page.article.share": "Share Article",
  "page.home.scroll": "Back to Top",
  "page.search.filter.category.label": "Categories",
  "page.search.filter.date.all": "All Time",
  "page.search.filter.date.label": "Date",
  "page.search.filter.date.month": "Past Month",
  "page.search.filter.date.today": "Past 24 hours",
  "page.search.filter.date.week": "Past Week",
  "page.search.filter.date.year": "This Year",
  "page.search.filter.sort.label": "Sort By",
  "page.search.filter.sort.newest": "Newest to Oldest",
  "page.search.filter.sort.oldest": "Oldest to Newest",
  "page.search.filter.sort.relevancy": "Relevancy",
  "page.search.header.placeholder": "Search",
  "page.search.header.results_for": "Showing Results for:",
  "page.search.no_results": "No results found",
  "page.tagresultspage.breadcrumbs.crunchyroll": "Crunchyroll",
};

const es = {
  "component.anime_series_carousel.possessivetitle": "Anime favorito de {name}",
  "component.anime_series_carousel.title": "Anime favorito de {name}",
  "component.article_card.aria.comment_button": "Comentar artículo",
  "component.article_card.aria.share_button": "Compartir artículo",
  "component.article_listing_by_cateogry_widget.headline":
    "Artículos relacionados",
  "component.articledetail.share": "Compartir",
  "component.articlepanels.html5audioembed.unsupported_message":
    "Tu navegador no soporta audio HTML.",
  "component.articlepanels.html5videoembed.unsupported_message":
    "Tu navegador no soporta vídeo HTML.",
  "component.authorpage.all_articles_by": "Todos los artículos de {name}",
  "component.authorpage.no_articles_found":
    "No se han encontrado artículos escritos por esta persona",
  "component.latest_news_featured_widget.all_button": "Todas las noticias",
  "component.latest_news_featured_widget.headline": "Últimas noticias",
  "component.latest_news_widget.all_button": "Todas las noticias",
  "component.latest_news_widget.headline": "Últimas noticias",
  "component.navbar.aria.account_menu": "Menú de la cuenta",
  "component.navbar.aria.account_thumbnail_alt": "Miniatura de usuario",
  "component.navbar.aria.mobile_menu_button": "Menú",
  "component.navbar.aria.search": "Buscar",
  "component.navbar.aria.search_menu": "Activar búsqueda",
  "component.navbar.aria.themetoggle": "Cambiar tema",
  "component.navbar.search.placeholder": "Buscar en Crunchyroll News",
  "component.pagination.aria.next_arrow": "Página siguiente",
  "component.pagination.aria.previous_arrow": "Página anterior",
  "component.product_listing.headline": "Productos recomendados",
  "component.series_listing_widget.headline": "Streaming recomendado",
  "component.spotlight_carousel.arrow_next": "Diapositiva siguiente",
  "component.spotlight_carousel.arrow_previous": "Diapositiva anterior",
  "component.spotlight_carousel.headline": "A Fondo",
  "component.top_stories_aside_widget.headline": "Historias principales",
  "component.top_stories_panel.headline": "Historias principales",
  "page.article.share": "Compartir artículo",
  "page.home.scroll": "Volver arriba",
  "page.search.filter.category.label": "Categorías",
  "page.search.filter.date.all": "En cualquier momento",
  "page.search.filter.date.label": "Fecha",
  "page.search.filter.date.month": "Mes pasado",
  "page.search.filter.date.today": "Últimas 24 horas",
  "page.search.filter.date.week": "Pasada semana",
  "page.search.filter.date.year": "Este año",
  "page.search.filter.sort.label": "Ordenar por",
  "page.search.filter.sort.newest": "Por fecha (nuevo primero)",
  "page.search.filter.sort.oldest": "Por fecha (antiguo primero)",
  "page.search.filter.sort.relevancy": "Relevancia",
  "page.search.header.placeholder": "Buscar",
  "page.search.header.results_for": "Mostrando resultados para:",
  "page.search.no_results": "No se han encontrado resultados",
  "page.tagresultspage.breadcrumbs.crunchyroll": "Crunchyroll",
};

const fr = {
  "component.anime_series_carousel.possessivetitle": "{name} animé préféré",
  "component.anime_series_carousel.title": "Anime préféré de {name}",
  "component.article_card.aria.comment_button": "Commenter l'article",
  "component.article_card.aria.share_button": "Partager l'article",
  "component.article_listing_by_cateogry_widget.headline":
    "Articles sur le même sujet",
  "component.articledetail.share": "Partager",
  "component.articlepanels.html5audioembed.unsupported_message":
    "Ton navigateur ne prend pas en charge le HTML audio",
  "component.articlepanels.html5videoembed.unsupported_message":
    "Ton navigateur ne prend pas en charge le HTML vidéo",
  "component.authorpage.all_articles_by": "Tous les articles de {name}",
  "component.authorpage.no_articles_found":
    "Aucun article trouvé concernant cet auteur",
  "component.latest_news_featured_widget.all_button": "Toutes les news",
  "component.latest_news_featured_widget.headline": "Dernières News",
  "component.latest_news_widget.all_button": "Toutes les news",
  "component.latest_news_widget.headline": "Dernières News",
  "component.navbar.aria.account_menu": "Menu du compte",
  "component.navbar.aria.account_thumbnail_alt": "Miniature utilisateur",
  "component.navbar.aria.mobile_menu_button": "Menu",
  "component.navbar.aria.search": "Rechercher",
  "component.navbar.aria.search_menu": "Inverser la recherche",
  "component.navbar.aria.themetoggle": "Inverser le thème",
  "component.navbar.search.placeholder": "Chercher dans les News Crunchyroll",
  "component.pagination.aria.next_arrow": "Page suivante",
  "component.pagination.aria.previous_arrow": "Page précédente",
  "component.product_listing.headline": "Produits recommandés",
  "component.series_listing_widget.headline": "Streaming recommandé",
  "component.spotlight_carousel.arrow_next": "Diapo suivante",
  "component.spotlight_carousel.arrow_previous": "Diapo précédente",
  "component.spotlight_carousel.headline": "Mis en avant",
  "component.top_stories_aside_widget.headline": "À la une",
  "component.top_stories_panel.headline": "À la une",
  "page.article.share": "Partager l'article",
  "page.home.scroll": "Retour en haut",
  "page.search.filter.category.label": "Catégories",
  "page.search.filter.date.all": "Depuis le début",
  "page.search.filter.date.label": "Date",
  "page.search.filter.date.month": "Mois dernier",
  "page.search.filter.date.today": "Dernières 24 heures",
  "page.search.filter.date.week": "Semaine dernière",
  "page.search.filter.date.year": "Cette année",
  "page.search.filter.sort.label": "Trier par",
  "page.search.filter.sort.newest": "De plus récent au plus ancien",
  "page.search.filter.sort.oldest": "Du plus ancien au plus récent",
  "page.search.filter.sort.relevancy": "Pertinence",
  "page.search.header.placeholder": "Rechercher",
  "page.search.header.results_for": "Résultats pour :",
  "page.search.no_results": "Aucun résultat",
  "page.tagresultspage.breadcrumbs.crunchyroll": "Crunchyroll",
};

const it = {
  "component.anime_series_carousel.possessivetitle":
    "Anime preferito di {name}",
  "component.anime_series_carousel.title": "Anime preferito di {name}",
  "component.article_card.aria.comment_button": "Commenta l'articolo",
  "component.article_card.aria.share_button": "Condividi articolo",
  "component.article_listing_by_cateogry_widget.headline": "Articoli correlati",
  "component.articledetail.share": "Condividi",
  "component.articlepanels.html5audioembed.unsupported_message":
    "Il tuo browser non supporta l'audio in HTML.",
  "component.articlepanels.html5videoembed.unsupported_message":
    "Il tuo browser non supporta i video in HTML.",
  "component.authorpage.all_articles_by": "Tutti gli articoli di {name}",
  "component.authorpage.no_articles_found":
    "Non è stato trovato nessun articolo scritto da questa persona",
  "component.latest_news_featured_widget.all_button": "Tutte le notizie",
  "component.latest_news_featured_widget.headline": "Ultime notizie",
  "component.latest_news_widget.all_button": "Tutte le notizie",
  "component.latest_news_widget.headline": "Ultime notizie",
  "component.navbar.aria.account_menu": "Menu dell'account",
  "component.navbar.aria.account_thumbnail_alt": "Immagine dell'utente",
  "component.navbar.aria.mobile_menu_button": "Menu",
  "component.navbar.aria.search": "Cerca",
  "component.navbar.aria.search_menu": "Attiva/Disattiva la ricerca",
  "component.navbar.aria.themetoggle": "Attiva/Disattiva il tema",
  "component.navbar.search.placeholder": "Cerca tra le News di Crunchyroll",
  "component.pagination.aria.next_arrow": "Pagina successiva",
  "component.pagination.aria.previous_arrow": "Pagina precedente",
  "component.product_listing.headline": "Prodotti suggeriti",
  "component.series_listing_widget.headline": "Serie consigliate",
  "component.spotlight_carousel.arrow_next": "Successivo",
  "component.spotlight_carousel.arrow_previous": "Precedente",
  "component.spotlight_carousel.headline": "In evidenza",
  "component.top_stories_aside_widget.headline": "Storie in evidenza",
  "component.top_stories_panel.headline": "Storie in evidenza",
  "page.article.share": "Condividi articolo",
  "page.home.scroll": "Torna all'inizio",
  "page.search.filter.category.label": "Categorie",
  "page.search.filter.date.all": "Dall'inizio",
  "page.search.filter.date.label": "Data",
  "page.search.filter.date.month": "Ultimo mese",
  "page.search.filter.date.today": "Ultime 24 ore",
  "page.search.filter.date.week": "Ultima settimana",
  "page.search.filter.date.year": "Quest'anno",
  "page.search.filter.sort.label": "Ordina per:",
  "page.search.filter.sort.newest": "Data (prima i più recenti)",
  "page.search.filter.sort.oldest": "Data (prima i più vecchi)",
  "page.search.filter.sort.relevancy": "Rilevanza",
  "page.search.header.placeholder": "Cerca",
  "page.search.header.results_for": "Risultati per:",
  "page.search.no_results": "Nessun risultato trovato",
  "page.tagresultspage.breadcrumbs.crunchyroll": "Crunchyroll",
};

const pt = {
  "component.anime_series_carousel.possessivetitle":
    "Animes favoritos de {name}",
  "component.anime_series_carousel.title": "Animes favoritos de {name}",
  "component.article_card.aria.comment_button": "Comentar",
  "component.article_card.aria.share_button": "Compartilhar artigo",
  "component.article_listing_by_cateogry_widget.headline": "Leia também",
  "component.articledetail.share": "Compartilhar",
  "component.articlepanels.html5audioembed.unsupported_message":
    "Seu navegador não tem suporte para áudio HTML.",
  "component.articlepanels.html5videoembed.unsupported_message":
    "Seu navegador não tem suporte para vídeo HTML.",
  "component.authorpage.all_articles_by":
    "Todos os artigos escritos por {name}",
  "component.authorpage.no_articles_found":
    "Não foram encontrados artigos escritos por essa pessoa",
  "component.latest_news_featured_widget.all_button": "Todas as notícias",
  "component.latest_news_featured_widget.headline": "Últimas notícias",
  "component.latest_news_widget.all_button": "Todas as notícias",
  "component.latest_news_widget.headline": "Últimas notícias",
  "component.navbar.aria.account_menu": "Menu da conta",
  "component.navbar.aria.account_thumbnail_alt": "Imagem de usuário",
  "component.navbar.aria.mobile_menu_button": "Menu",
  "component.navbar.aria.search": "Buscar",
  "component.navbar.aria.search_menu": "Ativar busca",
  "component.navbar.aria.themetoggle": "Mudar tema",
  "component.navbar.search.placeholder": "Procurar na Crunchyroll Notícias",
  "component.pagination.aria.next_arrow": "Próxima página",
  "component.pagination.aria.previous_arrow": "Página anterior",
  "component.product_listing.headline": "Produtos recomendados",
  "component.series_listing_widget.headline": "Séries recomendadas",
  "component.spotlight_carousel.arrow_next": "Próximo",
  "component.spotlight_carousel.arrow_previous": "Anterior",
  "component.spotlight_carousel.headline": "Destaque",
  "component.top_stories_aside_widget.headline": "Destaques",
  "component.top_stories_panel.headline": "Destaques",
  "page.article.share": "Compartilhar artigo",
  "page.home.scroll": "Voltar para o topo",
  "page.search.filter.category.label": "Categorias",
  "page.search.filter.date.all": "Todos os tempos",
  "page.search.filter.date.label": "Data",
  "page.search.filter.date.month": "Último mês",
  "page.search.filter.date.today": "Últimos 24 horas",
  "page.search.filter.date.week": "Última semana",
  "page.search.filter.date.year": "Este ano",
  "page.search.filter.sort.label": "Ordenar por",
  "page.search.filter.sort.newest": "Data (mais novo primeiro)",
  "page.search.filter.sort.oldest": "Data (mais antigo primeiro)",
  "page.search.filter.sort.relevancy": "Relevância",
  "page.search.header.placeholder": "Buscar",
  "page.search.header.results_for": "Mostrando resultados para:",
  "page.search.no_results": "Sem resultados",
  "page.tagresultspage.breadcrumbs.crunchyroll": "Crunchyroll",
};

const ru = {
  "component.anime_series_carousel.possessivetitle": "Любимое аниме {name}",
  "component.anime_series_carousel.title": "Любимое аниме {name}",
  "component.article_card.aria.comment_button": "Прокомментировать текст",
  "component.article_card.aria.share_button": "Поделиться текстом",
  "component.article_listing_by_cateogry_widget.headline": "Похожие тексты",
  "component.articledetail.share": "Поделиться",
  "component.articlepanels.html5audioembed.unsupported_message":
    "Ваш браузер не поддерживает HTML-аудио.",
  "component.articlepanels.html5videoembed.unsupported_message":
    "Ваш браузер не поддерживает HTML-видео.",
  "component.authorpage.all_articles_by": "Все тексты от {name}",
  "component.authorpage.no_articles_found":
    "Не найдено ни одного текста от этого автора",
  "component.latest_news_featured_widget.all_button": "Все новости",
  "component.latest_news_featured_widget.headline": "Последние новости",
  "component.latest_news_widget.all_button": "Все новости",
  "component.latest_news_widget.headline": "Последние новости",
  "component.navbar.aria.account_menu": "Меню профиля",
  "component.navbar.aria.account_thumbnail_alt": "Изображение пользователя",
  "component.navbar.aria.mobile_menu_button": "Меню",
  "component.navbar.aria.search": "Искать",
  "component.navbar.aria.search_menu": "Toggle поиск",
  "component.navbar.aria.themetoggle": "Toggle тема",
  "component.navbar.search.placeholder": "Искать в Crunchyroll News",
  "component.pagination.aria.next_arrow": "Следующая страница",
  "component.pagination.aria.previous_arrow": "Предыдущая страница",
  "component.product_listing.headline": "Рекомендованные товары",
  "component.series_listing_widget.headline": "Рекомендовано к просмотру",
  "component.spotlight_carousel.arrow_next": "Следующий слайд",
  "component.spotlight_carousel.arrow_previous": "Предыдущий слайд",
  "component.spotlight_carousel.headline": "Главное",
  "component.top_stories_aside_widget.headline": "Популярные статьи",
  "component.top_stories_panel.headline": "Популярные статьи",
  "page.article.share": "Поделиться текстом",
  "page.home.scroll": "Наверх",
  "page.search.filter.category.label": "Категории",
  "page.search.filter.date.all": "За всё время",
  "page.search.filter.date.label": "Дата",
  "page.search.filter.date.month": "Последний месяц",
  "page.search.filter.date.today": "Последние 24 часа",
  "page.search.filter.date.week": "Последняя неделя",
  "page.search.filter.date.year": "Этот год",
  "page.search.filter.sort.label": "Сортировать по",
  "page.search.filter.sort.newest": "От нового к старому",
  "page.search.filter.sort.oldest": "От старого к новому",
  "page.search.filter.sort.relevancy": "Релевантность",
  "page.search.header.placeholder": "Искать",
  "page.search.header.results_for": "Результаты для:",
  "page.search.no_results": "Нет результатов",
  "page.tagresultspage.breadcrumbs.crunchyroll": "Crunchyroll",
};

const messagesByKey = {
  "en-US": en,
  "es-419": es,
  "es-ES": es,
  "pt-BR": pt,
  "pt-PT": pt,
  "fr-FR": fr,
  "de-DE": de,
  "ar-SA": ar,
  "it-IT": it,
  "ru-RU": ru,
  "hi-IN": en,
};

export default messagesByKey;
